<template>
  <div class="pageMain" :class="globalDataArray.siteInfo.greyOut == 1 ? 'bigEventGray' : ''">
    <div class="four">
      <div class="four_mine">
        <img src="@/assets/images/404.jpg" alt="">
      </div>
      <p class="fnt_24">{{ globalDataArray.siteTemplateLanguage.page_nofound }}</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Nofound',
  data() {
    return {
      title: this.globalDataArray.siteInfo.title,
      description: this.globalDataArray.siteInfo.description,
      keywords: this.globalDataArray.siteInfo.keywords
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {

  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'keywords', name: 'keywords', content: this.keywords }
      ]
    }
  }
}
</script>
<style>
  .four p {
    color: #333333;
    text-align: center;
    width: 100%;

  }

  .four {
    position: relative;
    width: 100%;
    height: 100vh;
  }

  .four .four_mine {
    height: 100%;
    width: 100%;
  }

  .four .four_mine img {
    object-fit: cover;
    height: 100%;
    width: 100%;

  }

  .four p {
    position: absolute;
    transform: translate(-50%, -50%);
    bottom: 25%;
    left: 50%;
  }

  @media screen and (max-width: 768px) {
    .four {

      height: 100vh;
    }

    .four p {
      bottom: 22%;

    }
  }
</style>
